import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router';

import { Text } from '@actual-app/components/text';
import { theme } from '@actual-app/components/theme';
import { View } from '@actual-app/components/view';
import { send } from '@actual-app/core/platform/client/connection';

import { Link } from '#components/common/Link';

import { Title } from './common';

export function VerifyEmail() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [state, setState] = useState<'working' | 'done' | 'error'>('working');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      setState('error');
      setError('token-required');
      return;
    }
    void send('saas-verify-email', { token }).then(result => {
      if ('error' in result) {
        setState('error');
        setError(result.error);
      } else {
        setState('done');
      }
    });
  }, [token]);

  return (
    <View style={{ maxWidth: 450, marginTop: -30, color: theme.pageText }}>
      <Title text={t('Email verification')} />

      {state === 'working' && (
        <Text style={{ fontSize: 16 }}>
          <Trans>Verifying your email address…</Trans>
        </Text>
      )}

      {state === 'done' && (
        <Text style={{ fontSize: 16 }}>
          <Trans>
            Your email address is verified. You can{' '}
            <Link variant="internal" to="/login">
              sign in
            </Link>{' '}
            now.
          </Trans>
        </Text>
      )}

      {state === 'error' && (
        <Text style={{ fontSize: 16, color: theme.errorText }}>
          {error === 'token-expired' ? (
            <Trans>
              This verification link has expired. Sign in and request a new one
              from your account.
            </Trans>
          ) : (
            <Trans>
              This verification link is invalid. It may have already been used.
            </Trans>
          )}
        </Text>
      )}
    </View>
  );
}
